export default {
  nav: { title: 'Mon espace', home: 'Accueil', book: 'Réserver', properties: 'Mes propriétés', calendar: 'Calendrier', quotes: 'Soumissions', payments: 'Paiements', messages: 'Messages', account: 'Compte' },
  form: {
    required: 'Ce champ est requis.',
    invalid: 'Vérifiez cette valeur.',
  },
  errors: {
    CUTOFF_PASSED: 'Le délai de modification est dépassé. Écrivez à l’équipe pour toute demande.',
    JOB_CANCELLED: 'Ce ménage a été annulé : aucun paiement n’est requis.',
    AGREEMENT_NOT_ACTIVE: 'Ce service n’est pas actif pour le moment.',
    AGREEMENT_NOT_PAUSED: 'Ce service n’est pas en pause.',
    AGREEMENT_CLOSED: 'Ce service est déjà terminé ou annulé.',
    AGREEMENT_BILLED_PER_VISIT: 'Ce service est payé à chaque visite.',
    STAFF_ONLY_ACTION: 'Cette modification doit être faite par l’équipe. Écrivez-nous.',
    INVALID_TRANSITION: 'Cette action n’est plus possible. Actualisez la page.',
  },
  dashboard: {
    title: 'Bonjour {{name}}',
    subtitle: 'Vos ménages, vos soumissions et vos messages au même endroit.',
    book: 'Réserver un ménage',
    nextTitle: 'Prochain ménage',
    emptyTitle: 'Vous n’avez aucun ménage prévu.',
    emptyDescription: 'Demandez un ménage en quelques étapes : nous vous envoyons le prix officiel rapidement.',
    emptyNoProperty: 'Ajoutez votre adresse, puis demandez un ménage en quelques étapes.',
    requestCleaning: 'Demander un ménage',
    upcoming: 'Ménages à venir',
    history: 'Derniers ménages',
    openQuotes: 'Soumissions en cours',
    noOpenQuotes: 'Aucune soumission en cours.',
    properties_zero: 'Aucune propriété',
    properties_one: '{{count}} propriété',
    properties_other: '{{count}} propriétés',
    manageProperties: 'Gérer mes propriétés',
    addProperty: 'Ajouter une propriété',
  },
  job: {
    timeAt: 'à {{time}}',
    number: 'Ménage n° {{number}}',
    crew: 'Avec {{names}}',
    crewLabel: 'Équipe',
    crewPending: 'L’équipe sera confirmée prochainement.',
    recurring: 'Récurrent',
    messageSubject: 'Ménage n° {{number}} du {{date}}',
    when: 'Date et heure',
    duration: 'environ {{duration}}',
    seeProperty: 'Voir la propriété',
    price: 'Prix de ce ménage',
    partOfRecurring: 'Fait partie de votre service récurrent.',
    paymentDue: 'Montant à payer : {{amount}}',
    instructions: 'Instructions pour ce ménage',
    instructionsExplain: 'S’appliquent seulement à cette visite. Les consignes permanentes se trouvent dans la fiche de la propriété.',
    instructionsTitle: 'Instructions pour ce ménage',
    instructionsHint: 'Ex. : priorité à la cuisine, invités ce soir… Ces instructions ne valent que pour cette visite.',
    instructionsSaved: 'Instructions enregistrées.',
    noInstructions: 'Aucune instruction particulière pour cette visite.',
    reschedule: 'Changer la date ou l’heure',
    rescheduleTitle: 'Changer la date ou l’heure',
    rescheduleHint: 'Choisissez un nouveau moment. L’équipe confirmera la disponibilité.',
    rescheduleCrewNote: 'L’équipe prévue n’est peut-être pas disponible au nouveau moment : nous vous confirmerons qui viendra.',
    rescheduleSubmit: 'Confirmer le changement',
    rescheduled: 'Votre ménage a été déplacé.',
    cancel: 'Annuler ce ménage',
    cancelTitle: 'Annuler ce ménage?',
    cancelDescription: 'Le ménage du {{date}} à {{time}} sera annulé et l’équipe sera avisée.',
    cancelConfirm: 'Annuler le ménage',
    keep: 'Garder',
    cancelReason: 'Raison de l’annulation',
    cancelReasonHint: 'Quelques mots suffisent.',
    cancelReasonRequired: 'Indiquez la raison (au moins 2 caractères).',
    cancelled: 'Le ménage a été annulé.',
    cutoffRuleHours_one: '{{count}} h',
    cutoffRuleHours_other: '{{count}} h',
    cutoffRuleBusinessDays_one: '{{count}} jour ouvrable',
    cutoffRuleBusinessDays_other: '{{count}} jours ouvrables',
    cutoffOpen: 'Modification ou annulation possible en ligne jusqu’à : {{deadline}}.',
    cutoffLockedTitle: 'Le délai de modification de {{rule}} est dépassé.',
    cutoffLockedBody: 'Date limite : {{deadline}}. Pour tout changement ou annulation, écrivez à l’équipe : nous ferons notre possible.',
    writeTeam: 'Écrire à l’équipe',
  },
  book: {
    title: 'Demander un ménage',
    subtitle: 'Quelques questions simples. Le prix officiel est confirmé par notre équipe.',
    progress: 'Progression',
    stepOf: 'Étape {{step}} sur {{total}}',
    steps: {
      property: 'Propriété',
      service: 'Type de ménage',
      details: 'Votre logement',
      when: 'Date et heure',
      recurrence: 'Fréquence',
      requests: 'Demandes spéciales',
      summary: 'Résumé',
    },
    stepHints: {
      property: 'Où aura lieu le ménage?',
      service: 'Quel type de ménage souhaitez-vous?',
      details: 'Vérifiez les informations du logement : elles servent à préparer le prix.',
      when: 'Choisissez le moment qui vous convient.',
      recurrence: 'Une seule fois ou de façon régulière?',
      requests: 'Ajoutez des extras ou des précisions pour cette visite.',
      summary: 'Vérifiez votre demande avant de l’envoyer.',
    },
    noProperty: 'Ajoutez d’abord votre adresse.',
    noPropertyHint: 'Il faut une propriété pour demander un ménage.',
    otherProperty: 'Autre adresse',
    detailsHint: 'Les changements seront aussi enregistrés dans la fiche de votre propriété.',
    date: 'Date',
    time: 'Heure d’arrivée',
    hours: 'Entre {{from}} et {{to}}',
    workingDays: 'Jours de service : {{days}}',
    whenPreview: 'Ménage souhaité le {{date}} à {{time}}.',
    whenValue: '{{date}} à {{time}}',
    whenNote: 'La date est une préférence : l’équipe la confirme avec le prix.',
    frequency: 'Fréquence',
    frequencyHint: {
      ONE_TIME: 'Un ménage ponctuel.',
      WEEKLY: 'Le même jour chaque semaine.',
      BIWEEKLY: 'Une semaine sur deux.',
      MONTHLY: 'Une fois par mois.',
      CUSTOM: 'Vous choisissez l’intervalle.',
    },
    interval: 'Tous les combien de jours?',
    intervalHint: 'Entre 1 et 120 jours.',
    everyNDays_one: 'Chaque jour',
    everyNDays_other: 'Tous les {{count}} jours',
    contract: 'Engagement',
    contractHint: 'Un contrat est facultatif. L’équipe vous présentera les conditions avec le prix.',
    extras: 'Extras',
    extrasHint: 'Cochez ce que vous souhaitez ajouter à cette visite.',
    specialRequests: 'Demandes spéciales',
    specialRequestsHint: 'Ex. : priorité à la salle de bain, ne pas déplacer les plantes…',
    noRequests: 'Aucune demande spéciale.',
    estimateTitle: 'Prix indicatif',
    estimateRange: 'Entre {{low}} et {{high}}',
    estimateDuration: 'Durée estimée : environ {{duration}}',
    estimateUnavailable: 'Le prix indicatif n’est pas disponible pour le moment. Vous pouvez quand même envoyer votre demande.',
    estimateNote: 'Ce montant est une estimation. Le prix officiel est confirmé par notre équipe avant tout ménage : vous l’acceptez ou le refusez ensuite.',
    submit: 'Envoyer ma demande',
    submitted: 'Demande envoyée! Nous vous enverrons le prix officiel rapidement.',
    errors: {
      property: 'Choisissez une propriété.',
      service: 'Choisissez un type de ménage.',
      details: 'Les informations du logement ne sont pas encore chargées.',
      squareFeet: 'La superficie doit être entre 100 et 100 000 pi².',
      date: 'Choisissez une date à partir de demain.',
      time: 'Choisissez une heure.',
      closedDay: 'Nous ne faisons pas de ménage ce jour-là. Choisissez un autre jour.',
      interval: 'Indiquez un intervalle entre 1 et 120 jours.',
    },
  },
  properties: {
    title: 'Mes propriétés',
    subtitle: 'Vos adresses et les informations qui servent à chaque visite.',
    add: 'Ajouter une propriété',
    inactive: 'Inactive',
    bedBath: '{{bedrooms}} ch. · {{bathrooms}} sdb',
    pets: 'Animaux',
    emptyTitle: 'Aucune propriété pour le moment.',
    emptyDescription: 'Ajoutez votre adresse pour pouvoir demander un ménage.',
    newTitle: 'Nouvelle propriété',
    editTitle: 'Modifier la propriété',
    formSubtitle: 'Ces informations sont permanentes : elles s’appliquent à chaque ménage.',
    create: 'Ajouter la propriété',
    created: 'Propriété ajoutée.',
    saved: 'Propriété enregistrée.',
    bookHere: 'Réserver ici',
    map: 'Carte',
    roomsSummary: '{{bedrooms}} ch. · {{bathrooms}} sdb · {{floors}} étage(s)',
    kitchensFamily: '{{kitchens}} cuisine(s) · {{familyRooms}} salon(s)',
    sqft: '{{value}} pi²',
    permanentExplain: 'S’appliquent à chaque visite. Modifiez-les quand vos habitudes changent.',
    perVisitExplain: 'Pour une demande qui ne vaut que pour un ménage (invités, pièce prioritaire…), ajoutez-la lors de la réservation ou dans le détail de ce ménage.',
    noPermanent: 'Aucune consigne permanente.',
    addPermanent: 'En ajouter',
    teamNotes: 'Notes de l’équipe',
    noTeamNotes: 'Aucune note de l’équipe pour cette propriété.',
    sections: {
      address: 'Adresse',
      characteristics: 'Caractéristiques',
      permanent: 'Consignes permanentes',
      permanentHint: 'Valables pour chaque visite. Les instructions d’un seul ménage se donnent lors de la réservation.',
    },
    fields: {
      name: 'Nom de la propriété',
      nameHint: 'Ex. : Maison, Chalet, Condo du centre-ville',
      addressLine1: 'Adresse',
      unit: 'Appartement / unité',
      city: 'Ville',
      province: 'Province',
      postalCode: 'Code postal',
      propertyType: 'Type de logement',
      floors: 'Étages',
      bedrooms: 'Chambres',
      bathrooms: 'Salles de bain',
      kitchens: 'Cuisines',
      familyRooms: 'Salons / salles familiales',
      squareFeet: 'Superficie (pi²)',
      hasPets: 'Animaux à la maison',
      petDetails: 'Précisions sur les animaux',
      parkingInfo: 'Stationnement',
      permanentNotes: 'Consignes générales',
      permanentNotesHint: 'Ce que l’équipe doit savoir à chaque visite.',
      preferences: 'Préférences',
      specialProducts: 'Produits particuliers',
      forbiddenAreas: 'Pièces ou zones à éviter',
    },
  },
  access: {
    title: 'Accès au logement',
    privacy: 'Ces informations sont protégées : elles ne sont montrées aux employés qu’autour de leur visite.',
    empty: 'Aucune information d’accès. Ajoutez un code, une clé ou une alarme si l’équipe doit entrer sans vous.',
    addTitle: 'Ajouter une information d’accès',
    editTitle: 'Modifier l’information d’accès',
    dialogHint: 'Information permanente, utilisée à chaque visite.',
    kind: 'Type',
    label: 'Description',
    labelHint: 'Ex. : Porte avant, Boîte à clé côté garage',
    secret: 'Code ou valeur',
    secretHint: 'Facultatif. Visible seulement par vous et l’équipe autorisée.',
    notes: 'Précisions',
    show: 'Afficher le code',
    hide: 'Masquer le code',
    added: 'Information d’accès ajoutée.',
    updated: 'Information d’accès modifiée.',
    deleted: 'Information d’accès supprimée.',
    deleteTitle: 'Supprimer cette information d’accès?',
    deleteDescription: '« {{label}} » sera supprimée. L’équipe ne la verra plus.',
  },
  calendar: {
    title: 'Calendrier',
    subtitle: 'Vos ménages à venir et l’historique.',
    upcoming: 'À venir',
    history: 'Historique',
    historyEmpty: 'Aucun ménage passé pour le moment.',
  },
  quotes: {
    title: 'Soumissions',
    subtitle: 'Vos demandes de prix et leurs réponses.',
    number: 'Soumission n° {{number}}',
    requestedOn: 'Demandée le {{date}}',
    requestedFor: 'Souhaité le {{date}} à {{time}}',
    emptyTitle: 'Aucune soumission pour le moment.',
    emptyDescription: 'Demandez un ménage : nous vous enverrons le prix officiel.',
  },
  quote: {
    priceTitle: 'Notre prix',
    discount: 'Rabais',
    total: 'Total',
    totalPerVisit: 'Total par visite',
    duration_one: 'Durée estimée : {{duration}} · {{count}} personne',
    duration_other: 'Durée estimée : {{duration}} · {{count}} personnes',
    validUntil: 'Prix valide jusqu’au {{date}}.',
    preparingTitle: 'Notre équipe prépare votre prix.',
    preparingBody: 'Vous recevrez un avis dès qu’il sera prêt. Vous pourrez alors l’accepter ou le refuser.',
    cancelledTitle: 'Demande annulée.',
    cancelledBody: 'Cette demande n’est plus active. Vous pouvez en faire une nouvelle à tout moment.',
    yourNote: 'Votre commentaire',
    requestTitle: 'Votre demande',
    requestedDate: 'Date souhaitée',
    sentOn: 'Envoyée le',
    answerHint: 'Le prix vous convient?',
    accept: 'Accepter',
    reject: 'Refuser',
    acceptTitle: 'Accepter ce prix?',
    acceptDescription: 'Vous acceptez le prix de {{amount}}. Le ménage sera planifié et l’équipe sera avisée.',
    acceptDescriptionRecurring: 'Vous acceptez le prix de {{amount}} par visite. Vos ménages seront planifiés selon la fréquence choisie.',
    acceptNote: 'Un message pour l’équipe',
    rejectTitle: 'Refuser ce prix?',
    rejectDescription: 'L’équipe sera avisée. Dites-nous pourquoi si vous le souhaitez : nous pourrons peut-être vous proposer autre chose.',
    rejectNote: 'Raison du refus',
    acceptedToast: 'Prix accepté. Merci!',
    rejectedToast: 'Votre réponse a été envoyée.',
    acceptedTitle: 'C’est confirmé!',
    acceptedBody: 'Votre premier ménage est prévu le {{date}} à {{time}}.',
    acceptedBodyNoJob: 'L’équipe va planifier votre ménage et vous confirmera la date.',
    seeFirstJob: 'Voir le premier ménage',
    ask: 'Poser une question',
    askSubject: 'Question sur la soumission n° {{number}}',
    cancelRequest: 'Annuler la demande',
    cancelRequestTitle: 'Annuler cette demande?',
    cancelRequestDescription: 'L’équipe ne préparera pas de prix pour cette demande.',
    cancelledToast: 'Demande annulée.',
  },
  payments: {
    title: 'Paiements',
    subtitle: 'Vos montants à payer et vos reçus.',
    due: 'À payer',
    paid: 'Payé',
    toPay: 'À payer',
    historyTitle: 'Historique',
    pay: 'Payer',
    retry: 'Réessayer le paiement',
    cleaning: 'Ménage n° {{number}}',
    payment: 'Paiement',
    jobOn: 'Ménage du {{date}}',
    paidOn: 'payé le {{date}}',
    refunded: 'Remboursé : {{amount}}',
    seeCleaning: 'Voir le ménage',
    failedHint: 'Le paiement n’a pas fonctionné. Vous pouvez réessayer avec la même carte ou une autre.',
    contactToPay: 'Écrivez à l’équipe pour régler ce montant.',
    emptyTitle: 'Aucun paiement pour le moment.',
    emptyDescription: 'Les montants à payer apparaîtront ici après vos ménages.',
    successToast: 'Paiement reçu. Merci!',
    cancelledToast: 'Paiement annulé.',
    successBanner: 'Merci! Votre paiement a été reçu. Il peut prendre quelques secondes à apparaître ci-dessous.',
    cancelledBanner: 'Le paiement a été annulé. Aucun montant n’a été prélevé.',
  },
  messages: {
    title: 'Messages',
    subtitle: 'Écrivez à l’équipe : nous répondons rapidement.',
    new: 'Nouveau message',
    newTitle: 'Écrire à l’équipe',
    newDescription: 'Votre message est envoyé à notre équipe de service à la clientèle.',
    subject: 'Objet',
    body: 'Message',
    send: 'Envoyer',
    pick: 'Choisissez une conversation pour l’afficher.',
    relatedJob: 'Voir le ménage',
    relatedQuote: 'Voir la soumission',
    archived: 'Cette conversation est archivée. Écrivez un nouveau message au besoin.',
  },
  account: {
    title: 'Mon compte',
    subtitle: 'Vos coordonnées, votre langue et vos services récurrents.',
    profile: 'Coordonnées',
    displayName: 'Nom',
    emailHint: 'Pour changer votre courriel, écrivez à l’équipe.',
    secondaryPhone: 'Autre téléphone',
    saved: 'Coordonnées enregistrées.',
    language: 'Langue',
    languageHint: 'Langue de l’application et de vos courriels.',
    languageSaved: 'Langue enregistrée.',
    languageMismatch: 'Vos courriels sont envoyés dans l’autre langue. Choisissez une langue pour l’enregistrer.',
  },
  agreements: {
    title: 'Mes services récurrents',
    subtitle: 'Mettez un service en pause, reprenez-le ou annulez-le.',
    emptyTitle: 'Aucun service récurrent.',
    emptyDescription: 'Choisissez une fréquence lors de votre demande pour un ménage régulier.',
    since: 'Depuis le {{date}}',
    until: 'Jusqu’au {{date}}',
    pausedRange: 'En pause du {{from}} au {{until}}.',
    pausedOpen: 'En pause depuis le {{from}}.',
    pause: 'Mettre en pause',
    resume: 'Reprendre',
    cancel: 'Annuler le service',
    pauseTitle: 'Mettre le service en pause',
    pauseDescription: 'Les ménages prévus pendant la pause seront annulés. Vous pourrez reprendre à tout moment.',
    pauseFrom: 'À partir du',
    pauseUntil: 'Jusqu’au',
    pauseUntilHint: 'Facultatif : laissez vide pour reprendre vous-même plus tard.',
    pauseUntilError: 'La fin doit être après le début.',
    paused: 'Service mis en pause.',
    resumeTitle: 'Reprendre ce service?',
    resumeDescription: 'Les prochains ménages seront planifiés de nouveau selon la fréquence prévue.',
    resumed: 'Service repris.',
    cancelTitle: 'Annuler ce service récurrent?',
    cancelDescription: 'Les ménages futurs de ce service seront annulés. Les ménages passés et les paiements restent dans votre historique.',
    cancelConfirm: 'Annuler le service',
    cancelReason: 'Raison de l’annulation',
    cancelled: 'Service annulé.',
  },
};
